import { AdminUserManagement, UserManagement } from 'pages/users/components';

import { useCanAccess } from 'hooks/useCanAccess';
import { Unauthorized } from 'components/unauthorized';
import { TokenExpired } from 'components/tokenExpired';

export const UserManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('users');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <AdminUserManagement />
  ) : canAccess ? (
    <UserManagement />
  ) : (
    <Unauthorized />
  );
};
